import React from 'react';
import { Table, Button } from 'react-bootstrap';
import User from '../../lib/User';
import { user } from '../../lib/Users';
import UserJobsTable from './UserJobsTable';
import UserConversationTable from './UserConversationTable';
import { updateUser, updateProfile, deleteProfile, addProfile, deleteUser, fixStripe } from '../../lib/Users';
import UserTableRow from './individual_user_components/user_table_row';
import UserStats from './individual_user_components/user_stats';
import UserTags from './individual_user_components/user_tags';
import styled from 'styled-components';
import Helpers from '../../lib/Helpers'

const styles = {
  container: {
    display: 'flex',
  },
  profile_image_container: {
    width: '220px',
  },
  profile_image: {
    width: '100%',
  },
  profileTextContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
};

const NotesContainer = styled.div``;

const Note = styled.div`
  margin: 8px 0;
  padding: 15px;
  border-bottom: 1px solid;
`;

const NoteDate = styled.div`
  color: #222;
  font-size: 12px;
  margin-bottom: 5px;
`;

const NoteText = styled.p`
  font-size: 16px;
  font-style: italic;
  margin-bottom: 5px;
  overflow-wrap: break-word;
  word-wrap: break-word;
  hyphens: auto;
  display: block;
  overflow: hidden;
  white-space: normal;
`;

const newNoteDelimiter = '\n#NEW-NOTE#\n';

const dateSeparator = '\n---';

class UserPage extends React.Component {

  state = {
    user: null,
    stripe_accounts: [],
    jobs_posted: [],
    jobs_selected_for: []
  }

  componentDidMount() {
    user(this.props.match.params.swipecast_user_id).then((response)=> {
      this.setState({
        user: new User(response.user),
        stripe_accounts: response.stripe_accounts,
        jobs_posted: response.jobs_posted,
        jobs_selected_for: response.jobs_selected_for,
        conversations: response.conversations,
        stripe_customer: response.stripe_customer
      })
    });
  }

  saveAdminNotes = (notes) => {
    updateUser(
      this.state.user.swipecast_user_id,
      { admin_notes: notes },
    ).then(() => {
      const myUser = new User(this.state.user);
      myUser.admin_notes = notes;
      this.setState({ user: myUser });
    });
  }


  changeAdminNotes = (e) => {
    e.preventDefault();
    const $newNote = document.getElementById('newAdminNote');
    const today = new Date();
    if (e.target.innerHTML === 'Add New') { // Entering edit Mode
      $newNote.style.display = 'block';
      $newNote.focus();
      e.target.innerHTML = 'Save';
    } else {
      const newNoteValue = $newNote.value;
      e.target.innerHTML = 'Add New';
      $newNote.style.display = 'none';
      $newNote.value = '';
      if (newNoteValue === '') return;
      this.saveAdminNotes(
        this.state.user.admin_notes
        + newNoteDelimiter
        + (new Date()).toString() + dateSeparator
        + '\n' + newNoteValue
      );
    }
  }

  renderNotes = () => {
    return (
      <NotesContainer>
        {
          this.state.user.admin_notes ?
          this.state.user.admin_notes
          // New notes first
          .split(newNoteDelimiter).reverse()
          // Filter out empty notes
          .filter(note =>!(note.split(dateSeparator).length === 2 && !note.split(dateSeparator)[1].trim()))
          .map(note =>
            note.split(dateSeparator).length === 1
            ? (
              <Note>
                <NoteDate>(No Date)</NoteDate>
                <NoteText>{note.split(dateSeparator)[0]}</NoteText>
              </Note>
            )
            : (
              <Note>
                <NoteDate>{note.split(dateSeparator)[0]}</NoteDate>
                <NoteText>{note.split(dateSeparator)[1]}</NoteText>
              </Note>
          ))
          : 'No Notes'
        }
      </NotesContainer>
    );
  }

  addTag = (tag) => {
    const newUser = { ...this.state.user };
    const [profile] = newUser.profiles;
    const { tags } = profile;
    if (!tags) {
      profile.tags = [tag];
    } else {
      tags.push(tag);
      profile.tags = tags;
    }

    updateProfile(
      profile.swipecast_profile_id,
      { tags: profile.tags },
    ).then(() => {
      const myUser = new User(this.state.user);
      this.setState({ user: myUser });
    });
  }

  changeStat = (id, value) => {
    const newUser = { ...this.state.user };
    const [profile] = newUser.profiles;
    const { data } = profile;
    data[id] = value;
    updateProfile(
      profile.swipecast_profile_id,
      { data },
    ).then(() => {
      const myUser = new User(this.state.user);
      this.setState({ user: myUser });
    });
  }

  changeInsta = () => {
    const newHandle = window.prompt("Enter user's Instagram handle, without quotation marks (example: swipecast)");
    if (newHandle != null) {
      const newFollowers = window.prompt("Enter user's Instagram followers (example: 40000)");
      if (newFollowers != null && !isNaN(newFollowers)) {
        const newUser = { ...this.state.user };
        updateUser(this.state.user.swipecast_user_id, {
          instagram: newHandle,
          instagram_followers: newFollowers
        }).then(() => {
          window.location.reload();
        });
      }
    }
  }

  removeTag = (tag) => {
    const newUser = { ...this.state.user };
    const [profile] = newUser.profiles;
    const { tags } = profile;
    const index = tags.indexOf(tag);
    if (index > -1) {
      tags.splice(index, 1);
    }
    profile.tags = tags;
    updateProfile(
      profile.swipecast_profile_id,
      { tags },
    ).then(() => {
      const myUser = new User(this.state.user);
      this.setState({ user: myUser });
    });
  }

  putOnWaitlist = () => {
    if (window.prompt('Type the word "waitlist"') !== 'waitlist') return;
    updateUser(this.state.user.swipecast_user_id, {
      waitlisted: true
    }).then(() => {
      window.location.reload();
    });
  }

  deleteUserProfile = (swipecast_profile_id) => {
    deleteProfile(swipecast_profile_id).then((response) => {
      if (response.message) {
        window.alert(response.message);
      } else {
        window.location.reload();
      }
    });
  }

  deleteUser = (swipecast_user_id) => {
    deleteUser(swipecast_user_id).then((response) => {
      if (response.message) {
        window.alert(response.message);
      } else {
        window.location.reload();
      }
    });
  }

  fixStripe = (swipecast_user_id) => {
    fixStripe(swipecast_user_id).then((response) => {
      if (response.message) {
        window.alert(response.message);
      } else {
        window.location.reload();
      }
    });
  }

  addUserProfile = (profile_type, swipecast_user_id) => {
    addProfile(profile_type, swipecast_user_id).then((response) => {
      if (response.message) {
        window.alert(response.message);
      } else {
        window.location.reload();
      }
    });
  }

  render() {
    const {
      jobs_posted,
      jobs_selected_for,
      user,
      conversations,
      stripe_accounts,
      stripe_customer,
    } = this.state;
    if (user) {
      return (
        <UserPageVisual
          userObj={user}
          jobs_selected_for ={jobs_selected_for}
          jobs_posted={jobs_posted}
          stripe_accounts={stripe_accounts}
          conversations={conversations}
          addTag={this.addTag}
          removeTag={this.removeTag}
          changeStat={this.changeStat}
          changeAdminNotes={this.changeAdminNotes}
          putOnWaitlist={this.putOnWaitlist}
          stripe_customer={stripe_customer}
          deleteProfile={this.deleteUserProfile}
          deleteUser={this.deleteUser}
          fixStripe={this.fixStripe}
          addProfile={this.addUserProfile}
          renderNotes={this.renderNotes}
          changeInsta={this.changeInsta}
        />);
    }
    return <div/>;
  }
}


const UserPageVisual = ({
  userObj,
  changeAdminNotes,
  jobs_selected_for,
  jobs_posted,
  conversations,
  stripe_accounts,
  addTag,
  removeTag,
  changeStat,
  image,
  stripe_customer,
  putOnWaitlist,
  deleteProfile,
  deleteUser,
  addProfile,
  changeInsta,
  renderNotes
}) => {
  const user = new User(userObj);
  const [profile] = user.profiles;
  const modelProfile = user.profiles.filter(profile => profile.profile_type === 'Model')[0]
  const tags = profile && profile.tags ? [...profile.tags] : [];
  return (
    <div>
      <div style={styles.container}>
        <div style={styles.profile_image_container}>
          <img style={styles.profile_image} src={user.profileImage()} />
        </div>
        <div>
          <Table striped bordered condensed style={{ marginLeft: '20px'}}>
            <tbody>
              <UserTableRow>{user.full_name}</UserTableRow>
              <UserTableRow>
                <div style={styles.profileTextContainer}>
                  {
                    user.profiles.map(profile => {
                    return (
                      <div key={profile.swipecast_profile_id}>
                        {user.individualProfileText(profile)}
                        {` `}
                        <a href="#" onClick={(e) => {
                          e.preventDefault();
                          if (!window.confirm('Are you sure?')) return;
                          deleteProfile(profile.swipecast_profile_id)
                        }}>x</a>
                      </div>
                    )
                  })}
                </div>
              </UserTableRow>
              <UserTableRow>{user.email}</UserTableRow>
              <UserTableRow>{user.phone()}</UserTableRow>
              <UserTableRow>{
                user.waitlisted
                ? 'Waitlisted'
                : (
                  <div>
                    Not Waitlisted{` - `}
                    <a href="#" onClick={putOnWaitlist}>Put on Waitlist</a>
                  </div>
                )
              }</UserTableRow>
              {
                stripe_accounts.length > 0 && stripe_accounts.map((stripe_account, index)=>{
                  return (
                    <tr key={stripe_account.stripe_account_id}>
                      <td>
                        Stripe Account:{` `}
                        <a target='_blank' href={'https://dashboard.stripe.com/connect/accounts/' + stripe_account.stripe_account_id}>
                          {stripe_account.stripe_account_id}
                        </a>
                      </td>
                    </tr>
                  )
                })
              }
              {
                stripe_accounts.length > 0 &&
                <tr>
                  <td>
                    <a style={{color: 'red'}} href='#' onClick={(e) => {
                      e.preventDefault();
                      fixStripe(user.swipecast_user_id);
                    }}>
                      FIX STRIPE
                    </a>
                  </td>
                </tr>
              }
              {
                stripe_accounts.length == 0 &&
                <UserTableRow>No Stripe Accounts</UserTableRow>
              }
              {
                stripe_customer && (
                  <UserTableRow>
                    Stripe Customer:{` `}
                    <a target='_blank' href={'https://dashboard.stripe.com/customers/' + stripe_customer.stripe_customer_id}>
                      {stripe_customer.stripe_customer_id}
                    </a>
                  </UserTableRow>
                )
              }
              {
                <tr>
                  <td>
                    <a target='_blank' href={`${Helpers.frontendURL}/profile/${user.swipecast_user_id}`}>
                      Swipecast Profile
                    </a>
                  </td>
                </tr>
              }
              {
                user.website && <tr>
                  <td>
                    <a target='_blank' href={`http://${user.website}`}>
                      Website
                    </a>
                  </td>
                </tr>
              }
              {
                user.instagram && <tr>
                  <td>
                    IG Handle:
                    <a target="_blank" href={'https://www.instagram.com/'+user.instagram}>
                       {user.instagram}
                    </a>
                    <br></br>Followers: {user.instagram_followers}
                  </td>
                </tr>
              }
              {
                !user.instagram && <tr>
                  <td>
                    No Instagram Profile set
                  </td>
                </tr>
              }
              {
                <tr>
                  <Button
                    bsStyle="info"
                    style={{ marginLeft: '20px' }}
                    disabled={false}
                    onClick={changeInsta}
                  >
                  Update Instagram Info
                  </Button>
                </tr>
              }
              {
                !user.email.includes('DELETED_USER') && <tr>
                  <td>
                    <a style={{color: 'red'}} href='#' onClick={(e) => {
                      e.preventDefault();
                      if (
                        !window.prompt(`Type "${user.full_name.toLowerCase()}" (lowercase, no quotes) to continue`)
                        === user.full_name.toLowerCase()
                      ) return;
                      deleteUser(user.swipecast_user_id);
                    }}>
                      Delete User
                    </a>
                  </td>
                </tr>
              }
            </tbody>
          </Table>
        </div>
        <div>
          {
            modelProfile && <UserStats profile={modelProfile} changeStat={changeStat} />
          }
          <hr />
          <div style={{marginLeft: '25px'}}>
            <select id='profile_type' name='profile_type'>
              <option value='N/A'>-- Asign New Profile --</option>
              {
                user.profileTypes.map(type => (
                  <option key={type} value={type}>{type}</option>
                ))
              }
           </select>
            <a style={{marginLeft: '30px'}} onClick={e => {
              e.preventDefault();
              const selected = document.getElementById('profile_type').value;
              if (selected === 'N/A') return;
              addProfile(selected, user.swipecast_user_id)
            }} href="#">Save</a>
          </div>
        </div>
        {
          modelProfile && <div>
            <UserTags tags={tags} addTag={addTag} removeTag={removeTag} />
          </div>
        }
      </div>
      <div style={{marginTop: '10px', dispay: 'flex', flexDirection: 'column', width: '50%'}}>
        <div><b>Admin Notes</b> - <a href="#" onClick={changeAdminNotes}>Add New</a></div>
        <textarea id="newAdminNote" style={{width: '100%', height: '100px', display: 'none'}}></textarea>
        <div
          style={{ whiteSpace: 'pre', border: '1px solid #ddd', marginTop: '5px'}}>
          {renderNotes()}
        </div>
      </div>
      {
        jobs_posted.length > 0 &&
        <div>
          <h1>Jobs Posted</h1>
          <UserJobsTable jobs={jobs_posted}/>
        </div>
      }
      {
        jobs_selected_for.length > 0 &&
        <div>
          <h1>Jobs Selected For</h1>
          <UserJobsTable talent user={user} jobs={jobs_selected_for}/>
        </div>
      }
      {
        conversations && conversations.length > 0 &&
        <div>
          <h1>Conversations </h1>
          <UserConversationTable user={user} conversations={conversations}/>
        </div>
      }
    </div>
  )
};

export default UserPage;